import { FormElement } from "./createFormStructure";
import { FormValuesType } from "./Form";
import { FormData } from "@/getData/getIndexedFormsData";

export const isFieldVisible = (
  field: FormElement,
  formValues: FormValuesType,
  formData: FormData,
  visitedFields: Set<string> = new Set(), // Neu: Trackt bereits geprüfte Felder
): boolean => {
  if (visitedFields.has(field.name)) {
    console.warn(`Zirkelschluss in Formular-Logik erkannt: ${field.name}`);
    return false;
  }

  visitedFields.add(field.name);

  if (field.renderCondition && !field.renderCondition(formValues)) return false;

  if (field.display_condition) {
    const allInputFields = formData.formHeader.form.input_fields;
    if (!allInputFields) return false;

    const conditionFieldSource = allInputFields.find(
      (other) =>
        other.feld_name.toLowerCase() === field.condition_field.toLowerCase(),
    );

    if (!conditionFieldSource) return false;

    if (conditionFieldSource.display_condition) {
      if (
        !isFieldVisible(
          conditionFieldSource as unknown as FormElement,
          formValues,
          formData,
          visitedFields,
        )
      ) {
        return false;
      }
    }

    let compareValue = formValues[field.condition_field];

    switch (conditionFieldSource.input_type) {
      case "radiobutton": {
        const options = conditionFieldSource.radio_inputs;
        if (!options) break;
        const selectedOption = options[Number(compareValue)];
        compareValue = selectedOption
          ? (selectedOption.value ?? selectedOption.fieldlabel)
          : compareValue;
        break;
      }
      case "dropwdown": {
        const options = conditionFieldSource.dropdown_other_options;
        if (!options) break;
        if (conditionFieldSource.dropdown_multiselect) {
          if (Array.isArray(compareValue)) {
            const selectedOptions = compareValue.map((v) => {
              const item = options[Number.parseInt(v)];
              return item ? (item.value ?? item.fieldlabel) : v;
            });
            compareValue = selectedOptions.includes(field.condition_value)
              ? field.condition_value
              : "__FALSE__";
          }
        } else {
          const item = options[Number(compareValue)];
          compareValue = item ? (item.value ?? item.fieldlabel) : compareValue;
        }
        break;
      }
      case "checkbox": {
        if (compareValue === true) compareValue = "checked";
        break;
      }
    }

    if (compareValue !== field.condition_value) return false;
  }

  return true;
};
